import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IBlackListItem, IBlackListParams, IExportBlackListItem, IExportBlackListParams, IExportBlackListResult } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 风控管理 - 黑名单管理列表
 */
export async function queryBlackList(params: IBlackListParams, isLogin = false) {
  let data = [] as IBlackListItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.post<{ data: IBlackListItem[]; total: number }>(`${hostUrl}/${isLogin ? 'iam' : 'side'}/risk/${isLogin ? 'login' : 'distribute'}-deny/page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: resData, total: resTotal } = context || {};

      data = resData || [];
      total = resTotal || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 风控管理 - 黑名单管理 - 导入列表
 */
export async function queryCheckBlackList(params: IExportBlackListParams, isLogin = false, isAdd = false) {
  let data = [] as IExportBlackListItem[];
  let total = 0;
  let success = 0;
  let fail = 0;

  try {
    const { code, context, message } = await Http.post<IExportBlackListResult>(`${hostUrl}/${isLogin ? 'iam' : 'side'}/risk/${isLogin ? 'login' : 'distribute'}-deny/import-${isAdd ? 'add' : 'check'}`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { items, importCount, successCount, failCount } = context || {} as IExportBlackListResult;

      data = items;
      total = importCount;
      success = successCount;
      fail = failCount;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
    success,
    fail,
  };
}

/**
 * 风控管理 - 黑名单管理 - 删除
 */
export async function deleteBlackList(ids: number[], isLogin = false) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/${isLogin ? 'iam' : 'side'}/risk/${isLogin ? 'login' : 'distribute'}-deny/delete`, { ids });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 风控管理 - 黑名单管理 - 导出
 */

export async function exportRiskBlackList(params: IBlackListParams, isLogin = false) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/${isLogin ? 'iam' : 'side'}/risk/${isLogin ? 'login' : 'distribute'}-deny/export`,
      params,
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}